module.exports = __webpack_public_path__ + "media/applicants/shopping-cart-bf9ce469.png";